import styled from "styled-components"

export const StyledForm = styled.form`
  /* overflow: auto; */
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;

  & main:nth-last-of-type(1) {
    grid-column: span 2 / auto;
  }
`

export const StyledFormCopy = styled.div`
  margin: 12px 0 0;
  grid-column: span 2 / auto;

  & h3 {
    ${(props) => props.dark_form && `color: ${props.theme.colors.white};`}
    margin: 0;
  }
  & > div {
    & p {
      ${(props) =>
        props.dark_form && `color: ${props.theme.colors.white80true};`}
      margin-top: 8px;
    }
  }
`
